/**
 * @generated SignedSource<<1789a9e48d39bf392d2ddd9e0a5ad063>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FatcaQuestionType = "SINGLE_CHOICE";
export type FatcaQuestionsViewQuery$variables = Record<PropertyKey, never>;
export type FatcaQuestionsViewQuery$data = {
  readonly fatcaQuestions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly answers: ReadonlyArray<{
          readonly answer: string;
          readonly id: string;
          readonly translationKey: string;
        }>;
        readonly id: string;
        readonly question: string;
        readonly translationKey: string;
        readonly type: FatcaQuestionType;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type FatcaQuestionsViewQuery = {
  response: FatcaQuestionsViewQuery$data;
  variables: FatcaQuestionsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "translationKey",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FatcaQuestionsConnection",
    "kind": "LinkedField",
    "name": "fatcaQuestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FatcaQuestionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FatcaQuestion",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "question",
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FatcaAnswer",
                "kind": "LinkedField",
                "name": "answers",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answer",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FatcaQuestionsViewQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FatcaQuestionsViewQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "12adb7645b706c4a91460c119811a401",
    "id": null,
    "metadata": {},
    "name": "FatcaQuestionsViewQuery",
    "operationKind": "query",
    "text": "query FatcaQuestionsViewQuery {\n  fatcaQuestions {\n    edges {\n      node {\n        id\n        question\n        translationKey\n        type\n        answers {\n          id\n          answer\n          translationKey\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b42061b1d6ff7c201362c1b48fc6a554";

export default node;
